/**
 * Fetch-basierter API-Client mit axios-kompatibler Schnittstelle.
 * Gibt { data } zurück, wirft ApiError mit .response.data bei Fehlern.
 */

class ApiError extends Error {
  constructor(message, response) {
    super(message);
    this.response = response;
  }
}

function buildQuery(params) {
  if (!params) return "";
  return "?" + new URLSearchParams(params).toString();
}

async function handleResponse(res) {
  let data;
  const ct = res.headers.get("content-type") || "";
  try {
    data = ct.includes("application/json") ? await res.json() : await res.text();
  } catch {
    data = null;
  }
  if (!res.ok) {
    throw new ApiError(
      data?.detail || res.statusText,
      { data, status: res.status }
    );
  }
  return { data };
}

const api = {
  async get(url, config = {}) {
    const res = await fetch(url + buildQuery(config.params));
    return handleResponse(res);
  },

  async post(url, body, config = {}) {
    const opts = { method: "POST" };
    if (body != null) {
      opts.headers = { "Content-Type": "application/json" };
      opts.body = JSON.stringify(body);
    }
    const query = buildQuery(config?.params);
    const res = await fetch(url + query, opts);
    return handleResponse(res);
  },

  async put(url, body, config = {}) {
    const query = buildQuery(config?.params);
    const res = await fetch(url + query, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });
    return handleResponse(res);
  },

  async delete(url, config = {}) {
    const query = buildQuery(config?.params);
    const res = await fetch(url + query, { method: "DELETE" });
    return handleResponse(res);
  },
};

export default api;
